<!-- =========================================================================================
    File Name: Register.vue
    Description: Register Page
    ----------------------------------------------------------------------------------------
    Item Name: Vuesax Admin - VueJS Dashboard Admin Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <div class="h-screen flex w-full bg-img vx-row no-gutter items-center justify-center">
    <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-3/4 xl:w-3/5 sm:m-0 m-4">
      <vx-card>
        <div slot="no-body" class="full-page-bg-color">
          <div class="vx-row no-gutter">
            <div class="vx-col hidden sm:hidden md:hidden lg:block lg:w-1/2 mx-auto self-center">
              <img src="@/assets/images/pages/register.jpg" alt="register" class="mx-auto" />
            </div>
            <div class="vx-col sm:w-full md:w-full lg:w-1/2 mx-auto self-center d-theme-dark-bg">
              <div class="vx-logo flex justify-items-center items-center mb-2 pt-4">
                <img src="@/assets/images/logo/logo.png" alt="logo" class="mx-auto" style="max-height: 25px"/>
              </div>
              <div class="p-4 ml-8 mr-8">
                <div class="vx-card__title">
                  <h4 class="mb-3 grid justify-items-center">{{ socialRegister ? 'Falta pouco!' : 'Criar Conta' }}</h4>
                  <!-- <p>Informe os dados abaixo para criar uma nova conta</p> -->
                </div>

                <!--
                  Cadastro social sem o token: F5 no meio do caminho, ou entrada
                  direta na URL. O ID token vive em memória de propósito (ver
                  `moduleAuthState.socialSignup`), então só resta recomeçar.
                -->
                <div v-if="socialRegister && !hasSocialDraft" class="text-center py-4">
                  <p class="mb-3">
                    Sua sessão com o Google expirou antes de você concluir o cadastro.
                    Clique de novo no botão do Google e você volta para cá.
                  </p>
                  <vs-button to="/login">Voltar para o login</vs-button>
                </div>

                <div v-else class="clearfix">

                  <!-- Identidade confirmada pelo Google. Exibida, não editável: o
                       backend usa o e-mail do token, não o do formulário. -->
                  <div
                    v-if="socialRegister"
                    class="social-identity flex items-center mb-4 p-3 rounded"
                    style="background: rgba(115,103,240,0.08)"
                  >
                    <img
                      v-if="socialProfile.picture"
                      :src="socialProfile.picture"
                      alt=""
                      class="rounded-full mr-3"
                      style="width: 40px; height: 40px; object-fit: cover"
                    />
                    <div class="truncate">
                      <strong class="d-block truncate">{{ socialProfile.name }}</strong>
                      <small class="text-muted truncate">{{ socialProfile.email }}</small>
                    </div>
                  </div>

                  <!--
                    Intenção declarada, não perfil de acesso.

                    O `person_type` daqui era descartado em silêncio pelo backend
                    (que lê `role`, e esta tela nunca mandou `role`): o rádio era
                    obrigatório e não tinha efeito nenhum — toda conta criada por
                    aqui virava aluno, tivesse a pessoa marcado o que marcasse.

                    Hoje a escolha é gravada em `users.signup_intent` e aparece
                    para quem cuida do relacionamento. O que ela continua **não**
                    fazendo é conceder o perfil de professor: conta de professor
                    precisa da linha `ppl.teachers` e do vínculo com um clube, e
                    quem vincula professor a clube é o clube. Daí o aviso abaixo —
                    sem ele, marcar "Professor" promete um acesso que não vem.
                  -->
                  <div class="pb-1 pt-2">
                   <!-- <label for="person_type">Tipo Usuário:</label>-->
                    <div id="person_type" class="grid mt-1 justify-items-center">
                      <vs-radio class="hidden w-0 h-0" v-model="personType" vs-name="person_type" vs-value="none">NENHUM</vs-radio>
                      <!-- Rótulos literais: `$t('Student')` / `$t('Teacher')` não existem no
                           dicionário e o vue-i18n devolve a própria chave — a tela de
                           cadastro de um produto em pt-BR mostrava "Student" e "Teacher". -->
                      <vs-radio v-model="personType" vs-name="person_type" vs-value="student">Aluno</vs-radio>
                      <vs-radio v-model="personType" vs-name="person_type" vs-value="teacher">Professor</vs-radio>
                      <span class="text-danger text-sm col-span-2 mt-2">{{ erros.personType }}</span>
                    </div>
                    <small v-if="personType === 'teacher'" class="text-muted d-block mt-2 text-center">
                      Sua conta começa como aluno. Para dar aulas na plataforma, o
                      estabelecimento em que você trabalha precisa vincular você ao
                      cadastro dele — avisaremos assim que isso for possível.
                    </small>
                  </div>

                  <div v-if="!socialRegister" class="pb-1 pt-1">
                    <label for="name">Nome:</label>
                    <vs-input
                      id="name"
                      name="name"
                      v-model="formName"
                      class="w-full"
                    />
                    <span class="text-danger text-sm">{{ erros.name }}</span>
                  </div>

                  <div v-if="!socialRegister" class="pb-1 pt-1">
                    <label for="email">Email:</label>
                    <vs-input
                      id="email"
                      name="email"
                      type="email"
                      v-model="formEmail"
                      class="w-full"
                    />
                    <span class="text-danger text-sm">{{ erros.email }}</span>
                  </div>

                  <!--
                    CPF e data de nascimento não existiam neste formulário, e o
                    backend exige os dois: `cpf` desde sempre (o cadastro daqui
                    já devolvia 422 antes desta mudança) e `birthdate` a partir
                    da verificação de idade mínima da LGPD (Art. 14).

                    Valem **também** no cadastro social: o Google não devolve
                    nenhum dos dois. Estavam escondidos no caminho social, que por
                    isso levava 422 garantido do backend.
                  -->
                  <div class="pb-1 pt-1">
                    <label for="cpf">CPF:</label>
                    <vs-input
                      id="cpf"
                      name="cpf"
                      v-model="cpf"
                      class="w-full"
                    />
                    <span class="text-danger text-sm">{{ erros.cpf }}</span>
                  </div>

                  <div class="pb-1 pt-1">
                    <label for="birthdate">Data de nascimento:</label>
                    <vs-input
                      type="date"
                      id="birthdate"
                      name="birthdate"
                      v-model="birthdate"
                      class="w-full"
                    />
                    <span class="text-danger text-sm">{{ erros.birthdate }}</span>
                    <span v-if="birthdate && !isOfAge" class="text-danger text-sm d-block">
                      É necessário ter pelo menos {{ minAge }} anos.
                    </span>
                    <small class="text-muted d-block mt-1">
                      O cadastro é para maiores de {{ minAge }} anos. Menores participam
                      das atividades matriculados por um responsável legal.
                    </small>
                  </div>

                  <!-- Sem campos de senha no cadastro social: a conta entra pelo
                       Google e nasce sem senha. Quem quiser uma cria depois, pelo
                       perfil ou por "esqueci minha senha". -->
                  <div v-if="!socialRegister" class="pb-1 pt-1">
                    <label for="password">Senha:</label>
                    <vs-input
                      ref="password"
                      type="password"
                      id="password"
                      name="password"
                      v-model="password"
                      class="w-full"
                    />
                    <span class="text-danger text-sm">{{ erros.password }}</span>
                  </div>

                  <div v-if="!socialRegister" class="pb-1 pt-1">
                    <label for="password_confirmation">Confirmação Senha:</label>
                    <vs-input
                      type="password"
                      id="password_confirmation"
                      name="password_confirmation"
                      v-model="password_confirmation"
                      class="w-full"
                    />
                    <span class="text-danger text-sm">{{ erros.password_confirmation }}</span>
                  </div>
                  <!--
                    Dois aceites, ambos desmarcados por padrão, cada um com link
                    para o texto real e a versão que está sendo aceita.
                    Antes: um checkbox só, já marcado (`true` no data), apontando
                    para um domínio fora do ar, e o aceite nunca era enviado ao
                    servidor — nada disso é consentimento (LGPD, Art. 8º).
                  -->
                  <div class="flex flex-wrap justify-left my-1">
                    <b-form-checkbox v-model="isTermsConditionAccepted" class="mb-2">
                      Li e aceito os
                      <router-link to="/termos" target="_blank">Termos de Uso</router-link>
                      <small v-if="termsVersion" class="text-muted">v{{ termsVersion }}</small>
                    </b-form-checkbox>
                  </div>
                  <div class="flex flex-wrap justify-left my-1">
                    <b-form-checkbox v-model="isPrivacyPolicyAccepted" class="mb-3">
                      Li e aceito a
                      <router-link to="/privacidade" target="_blank">Política de Privacidade</router-link>
                      <small v-if="privacyVersion" class="text-muted">v{{ privacyVersion }}</small>
                    </b-form-checkbox>
                  </div>
                  <div class="flex flex-wrap justify-center mt-4 mr-4 ml-4">
                    <vs-button
                      class="w-full sm:w-auto sm:mb-auto sm:mt-auto mt-4 mr-4 ml-4"
                      @click="registerUser"
                      :disabled="!validateForm">Registrar</vs-button>
                    <vs-button type="border" to="/login" class="w-full sm:w-auto sm:mb-auto sm:mt-auto mt-1  mr-4 ml-4">Voltar</vs-button>
                  </div>

                  <p v-if="socialRegister" class="text-center text-muted mt-3 mb-0">
                    <small>
                      Sua conta vai entrar pelo Google, sem senha. Se um dia quiser uma,
                      use "Esqueceu a senha?" na tela de login.
                    </small>
                  </p>

                  <!-- reCAPTCHA só no cadastro por formulário: no social o próprio
                       ID token do Google já é a prova de que há gente do outro lado. -->
                  <recaptcha-notice v-if="!socialRegister" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </vx-card>
    </div>
  </div>
</template>

<script>

import UserService from '@/services/api/UserService'

import {
  BForm, BButton, BFormInput, BFormGroup, BFormCheckbox
} from 'bootstrap-vue'
import RecaptchaNotice from '@/components/RecaptchaNotice.vue'
import recaptchaMixin from '@/mixins/recaptcha'
import { LegalDocumentService } from '@/services/api/PrivacyService'
import { MIN_AGE } from '@core/utils/validations/validations'

export default {
  /*
   * `vSelect`, `ValidationProvider` e `ValidationObserver` estavam registrados
   * aqui **sem import nenhum**. Como o bloco `components` avalia os
   * identificadores na hora de definir o componente, o resultado era
   * `ReferenceError: vSelect is not defined` — o componente nem chegava a ser
   * criado e a tela de cadastro do backoffice não renderizava, caindo para `/`.
   *
   * Nenhum dos três aparece no template (o formulário é vs-input, vs-radio,
   * b-form-checkbox e vs-button), então o conserto é remover o registro morto,
   * não importar biblioteca que a tela não usa.
   */
  components: {
    RecaptchaNotice,
    // BSV
    BForm,
    BButton,
    BFormInput,
    BFormGroup,
    BFormCheckbox,
  },
  mixins: [recaptchaMixin],
  props: {
    name: {
      type: String,
      default: '',
    },
    email: {
      type: String,
      default: '',
    },
    token: {
      type: String,
      default: '',
    },
    provider: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      // Cópias locais de `name`/`email`: são props, e o formulário as edita —
      // `v-model` direto numa prop é mutação de prop (aviso do Vue) e, no caminho
      // social, os valores vêm do token, não da rota.
      formName: '',
      formEmail: '',
      password: '',
      password_confirmation: '',
      cpf: '',
      birthdate: '',
      // Desmarcados: caixa pré-marcada não é manifestação inequívoca (Art. 5º, XII).
      isTermsConditionAccepted: false,
      isPrivacyPolicyAccepted: false,
      // Versões vigentes, do backend — é o que viaja no aceite e o que diz
      // *qual texto* a pessoa leu.
      termsVersion: null,
      privacyVersion: null,
      personType: 'none',
      socialRegister: false,

      /*
       * Mensagens de erro por campo, em JS puro.
       *
       * A tela usava `v-validate` / `errors.first()` / `this.$validator`, que são a
       * API do **vee-validate 2** — e o projeto tem o **3**, onde a diretiva nem é
       * registrada. `errors` chegava `undefined`, e como `errors.first('person_type')`
       * é avaliado logo no início do template, o render explodia inteiro: a tela de
       * cadastro do backoffice não desenhava **nada**, com ou sem SSO. Pelo mesmo
       * motivo `showErrors(this.$validator, ...)` descartava em silêncio os erros que
       * o servidor devolvia.
       *
       * A validação aqui é a mesma do cadastro do marketplace: sem biblioteca, o
       * formulário decide o que exigir e o backend continua sendo a autoridade.
       */
      erros: {
        personType: '',
        name: '',
        email: '',
        cpf: '',
        birthdate: '',
        password: '',
        password_confirmation: ''
      }
    }
  },
  mounted() {
    this.loadDocumentVersions()
  },
  computed: {
    /** Cadastro social em andamento (ID token + perfil), guardado em memória. */
    socialDraft() {
      return this.$store.state.auth.socialSignup
    },
    hasSocialDraft() {
      return Boolean(this.socialDraft && this.socialDraft.idToken)
    },
    socialProfile() {
      return (this.socialDraft && this.socialDraft.profile) || {}
    },
    validateForm() {
      return (
        this.formName !== '' &&
        this.formEmail !== '' &&
        // Sem senha no caminho social — a conta nasce sem uma.
        (this.socialRegister || (this.password !== '' && this.password_confirmation !== '')) &&
        (this.personType !== 'none' && this.personType !== null) &&
        // CPF e nascimento valem nos DOIS caminhos: o Google não fornece nenhum
        // dos dois, e o backend exige ambos.
        (this.cpf !== '' && this.birthdate !== '' && this.isOfAge) &&
        this.isTermsConditionAccepted === true &&
        this.isPrivacyPolicyAccepted === true
      )
    },
    minAge() {
      return MIN_AGE
    },
    /** Idade em anos completos — o aniversário precisa ter passado. */
    isOfAge() {
      if (!this.birthdate) return false

      const birthDate = new Date(this.birthdate)
      if (isNaN(birthDate.getTime()) || birthDate > new Date()) return false

      const today = new Date()
      let age = today.getFullYear() - birthDate.getFullYear()
      const monthDiff = today.getMonth() - birthDate.getMonth()
      if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) age -= 1

      return age >= MIN_AGE
    }
    // `personTypeList` vivia aqui e não era usado por nada: o template monta os
    // dois rádios na mão. Duas listas de opções para o mesmo campo, uma delas
    // morta, só dão trabalho a quem for mexer no campo depois.
  },
  methods: {
    /**
     * Versão vigente de cada documento legal.
     *
     * O backend recusa aceite de versão que não seja a atual — aba aberta há
     * semanas gravaria consentimento de um texto que a pessoa não leu.
     *
     * Vem de `LegalDocumentService` (endpoint público, fora do prefixo `/privacy`,
     * que exige o papel `admin`). Esta tela chamava `PrivacyService.documents()` —
     * método que não existe na classe padrão: a chamada estourava, o `catch` a
     * engolia, as versões ficavam nulas e o cadastro do backoffice era **sempre**
     * recusado pelo servidor com "é necessário aceitar os Termos de Uso".
     */
    async loadDocumentVersions() {
      try {
        const response = await LegalDocumentService.build().documents()
        const data = typeof response === 'string' ? JSON.parse(response) : response
        const docs = (data && data.documents) || []

        this.termsVersion = (docs.find(d => d.key === 'terms') || {}).version || null
        this.privacyVersion = (docs.find(d => d.key === 'privacy') || {}).version || null
      } catch (e) {
        this.termsVersion = null
        this.privacyVersion = null
      }
    },
    /**
     * Validação do formulário, em JS puro — ver a nota em `data.erros`.
     *
     * Só o que a tela consegue afirmar sozinha. CPF válido, unicidade e versão
     * vigente dos documentos continuam sendo decisão do backend, e a resposta dele
     * volta para o campo em `aplicarErrosDoServidor`.
     */
    validarCampo(campo) {
      this.erros[campo] = ''

      switch (campo) {
      case 'personType':
        if (this.personType === 'none' || !this.personType) {
          this.erros.personType = 'Você deve escolher um tipo de usuário'
        }
        break

      case 'name':
        if (!this.socialRegister && !this.formName.trim()) this.erros.name = 'O nome é obrigatório'
        break

      case 'email':
        if (this.socialRegister) break
        if (!this.formEmail.trim()) this.erros.email = 'O e-mail é obrigatório'
        else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.formEmail)) this.erros.email = 'E-mail inválido'
        break

      case 'cpf':
        if (!this.cpf.trim()) this.erros.cpf = 'O CPF é obrigatório'
        break

      case 'birthdate':
        if (!this.birthdate) this.erros.birthdate = 'A data de nascimento é obrigatória'
        else if (!this.isOfAge) this.erros.birthdate = `É necessário ter pelo menos ${this.minAge} anos`
        break

      case 'password':
        if (!this.socialRegister && !this.password) this.erros.password = 'A senha é obrigatória'
        break

      case 'password_confirmation':
        if (this.socialRegister) break
        if (!this.password_confirmation) this.erros.password_confirmation = 'Confirme a senha'
        else if (this.password !== this.password_confirmation) this.erros.password_confirmation = 'As senhas não coincidem'
        break
      }

      return !this.erros[campo]
    },

    validarTudo() {
      const campos = ['personType', 'name', 'email', 'cpf', 'birthdate', 'password', 'password_confirmation']
      return campos.map(c => this.validarCampo(c)).every(Boolean)
    },

    /**
     * Erros de validação do servidor voltam para o campo que os causou.
     *
     * Substitui `showErrors(this.$validator, ...)`, que chamava `setErrors()` num
     * `$validator` inexistente (API do vee-validate 2) — ou seja, o 422 do backend
     * era descartado em silêncio e o formulário parecia travar sem motivo.
     */
    aplicarErrosDoServidor(error) {
      let data = error && error.data
      if (typeof data === 'string') {
        try {
          data = JSON.parse(data)
        } catch (e) {
          data = null
        }
      }

      if (!data || !data.errors) return

      const mapa = {
        name: 'name',
        email: 'email',
        cpf: 'cpf',
        birthdate: 'birthdate',
        password: 'password',
        password_confirmation: 'password_confirmation',
        accepted_terms_version: 'personType',
        accepted_privacy_version: 'personType'
      }

      Object.keys(mapa).forEach(campoApi => {
        if (!data.errors[campoApi]) return
        const msg = Array.isArray(data.errors[campoApi]) ? data.errors[campoApi][0] : data.errors[campoApi]
        this.erros[mapa[campoApi]] = msg
      })
    },

    /**
     * Garante que o aceite vai com a versão do documento.
     *
     * Sem ela o backend recusa com "é necessário aceitar os Termos" — mensagem sem
     * sentido para quem acabou de marcar as duas caixas. Acontece quando o envio
     * chega antes de a busca das versões terminar (rede lenta) ou quando ela falhou
     * no `mounted`. Uma segunda tentativa resolve o caso comum; persistindo, a tela
     * diz o que houve em vez de mandar um aceite vazio.
     */
    async assegurarVersoesDosDocumentos() {
      if (this.termsVersion && this.privacyVersion) return true

      await this.loadDocumentVersions()

      if (this.termsVersion && this.privacyVersion) return true

      this.notifyError(
        this.$vs,
        'Não conseguimos carregar os Termos e a Política agora. Recarregue a página e tente de novo.',
        6000
      )

      return false
    },

    async registerUser() {
      if (!this.validarTudo()) return false
      if (!this.validateForm) return false
      if (this.$store.state.auth.isUserLoggedIn()) {
        this.notifyAlreadyLogedIn()
        return
      }

      if (!(await this.assegurarVersoesDosDocumentos())) return

      if (this.socialRegister) {
        return this.registerSocialUser()
      }

      this.$vs.loading()

      const recaptchaToken = await this.getRecaptchaToken('register')

      const payload = {
        userDetails: {
          name: this.formName,
          email: this.formEmail,
          password: this.password,
          password_confirmation: this.password_confirmation,
          person_type: (this.personType === 'none') ? null : this.personType,
          recaptcha_token: recaptchaToken,
          cpf: this.cpf,
          birthdate: this.birthdate,
          // Prova do consentimento (LGPD, Art. 8º, §2º).
          accepted_terms_version: this.termsVersion,
          accepted_privacy_version: this.privacyVersion
        },
        vs: this.$vs,
        closeAnimation: () => {
          this.$vs.loading.close()
        },
        showErrors: (error) => {
          this.aplicarErrosDoServidor(error)
        }
      }
      this.$store.dispatch('auth/registerUser', payload)
    },

    /**
     * Conclusão do cadastro iniciado pelo Google.
     *
     * Não manda nome, e-mail nem senha: os dois primeiros vêm do ID token (fonte
     * confiável) e o terceiro não existe nessas contas. A resposta já é a sessão
     * pronta — o fluxo antigo tentava um `login` com senha logo depois, o que numa
     * conta sem senha é impossível.
     */
    registerSocialUser() {
      this.$vs.loading()

      this.$store.dispatch('auth/socialRegister', {
        fields: {
          person_type: (this.personType === 'none') ? null : this.personType,
          cpf: this.cpf,
          birthdate: this.birthdate,
          accepted_terms_version: this.termsVersion,
          accepted_privacy_version: this.privacyVersion
        },
        vs: this.$vs,
        acl: this.$acl,
        closeAnimation: () => {
          this.$vs.loading.close()
        },
        onError: (error) => {
          this.aplicarErrosDoServidor(error)
        },
        onExpired: () => {
          this.$store.commit('auth/CLEAR_SOCIAL_SIGNUP')
        }
      })
    },

    notifyAlreadyLogedIn() {
      this.$vs.notify({
        title: 'Login Attempt',
        text: 'You are already logged in!',
        iconPack: 'feather',
        icon: 'icon-alert-circle',
        color: 'warning'
      })
    }
  },
  created() {
    if (this.$route.name === 'social_register') {
      this.socialRegister = true

      // Identidade vem do rascunho em memória (o que o backend devolveu ao
      // recusar o login por e-mail desconhecido), não da rota.
      this.formName = this.socialProfile.name || ''
      this.formEmail = this.socialProfile.email || ''
      return
    }

    this.formName = this.name || ''
    this.formEmail = this.email || ''
  }
}
</script>
